
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/bgSignup.png";
import API_URL from "../../services/api";
import "./Signup.css";

const Signup = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSignup = async () => {
    setPasswordError("");

    if (!name || !email || !password) {
      setPasswordError("Please fill all fields.");
      return;
    }

    if (password.length < 8) {
      setPasswordError(
        "Password must be at least 8 characters long."
      );
      return;
    }

    const payload = {
      name,
      email,
      password,
    };

    setLoading(true);

    try {
      const response = await fetch(
        `${API_URL}/api/auth/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      setLoading(false);

      if (response.ok) {
        alert("Account created successfully!");
        navigate("/login");
      } else {
        setPasswordError(
          data.message || "Signup failed."
        );
      }
    } catch (error) {
      setLoading(false);

      console.log("SIGNUP ERROR:", error);

      setPasswordError("Server not reachable.");
    }
  };

  return (
    <div
      className="signup-page"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="signup-card">

        <div className="signup-content">

          <h2 className="signup-title">
            User Signup
          </h2>

          <p className="signup-subtitle">
            Create your library account
          </p>

          <input
            className="signup-input"
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <input
            className="signup-input"
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="signup-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !loading) {
                handleSignup();
              }
            }}
          />

          {passwordError && (
            <p className="signup-error">
              {passwordError}
            </p>
          )}

          <button
            className="signup-button"
            onClick={handleSignup}
            disabled={loading}
          >
            {loading ? "Creating Account..." : "Signup"}
          </button>

          <p className="signup-footer">
            Already have an account?{" "}

            <span
              onClick={() => navigate("/login")}
              className="signup-link"
            >
              Login
            </span>
          </p>

        </div>

      </div>
    </div>
  );
};

export default Signup;
